import React from "react";
import { Link } from "react-router";
import moment from "moment";
import Helpers from "../../../helpers/helperFunctions";
import { niceEventName } from "../../../helpers/sport/eventNames";
import Event from "../event";

export default function matchOfTheDayGameTemplate() {
	let { game } = this.props;
	const gameType = game.type !== 1 ? "prematch" : "live";

	return (
		<li key={game.id}>
			<Link
				className="link-view-home-slider"
				to={`/${gameType}/${game.sportAlias}/${game.region.id}/${game.competition.id}/${game.id}`}
			/>
			<div className="single-game-view">
				<div className="name-date-g-t">
					<ul>
						<li>{game.sportName}</li>
						<li>{moment.unix(game.start_ts).format("DD.MM.YYYY - HH:mm")}</li>
					</ul>
				</div>
				<div className="team-name-market-count-t">
					<ul>
						<li>
							<p>{game.team1_name}</p>
							<p>{game.team2_name}</p>
						</li>
						<li>
							<span>+{game.markets_count}</span>
						</li>
					</ul>
				</div>
				<div className="game-coefficient-v-t">
					<ul>
						{Helpers.objectToArray(Helpers.firstElement(game.market)?.event)
							.sort((a, b) => a.order - b.order)
							.map((event, i) => {
								return (
									<li key={i}>
										<Event
											event={event}
											name={niceEventName(
												event.name,
												game
											)}
											price={event.price}
											game={game}
											market={Helpers.firstElement(
												game.market
											)}
											gameType={gameType}
										/>
									</li>
								);
							})}
					</ul>
				</div>
			</div>
		</li>
	);
}
